import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';

export class ControleDetails {
    static jsonMap = {
        idProduit: 'idProduit',
        codeProduit: 'codeProduit',
        libelleProduit: 'libelleProduit',
        millesime: 'millesime',
        numeroLot: 'numeroLot',
        logement: 'logement',
        volume: 'volume',
        datePrelevement: { key: 'datePrelevement', converter: new DateConverter() },
        dateControle: { key: 'dateControle', converter: new DateConverter() },
        libelleMouvement: 'libelleMouvement',
        idEchantillon: 'idEchantillon',
        numeroEchantillon: 'numeroEchantillon',
        numeroExpertise: 'numeroExpertise'
    };

    idProduit: number;
    codeProduit: string;
    libelleProduit: string;
    millesime: number;
    numeroLot: string;
    logement: string;
    volume: number;
    datePrelevement: moment.Moment;
    dateControle: moment.Moment;
    libelleMouvement: string;
    idEchantillon: number;
    numeroEchantillon: string;
    numeroExpertise: number;
}
